/**
 * The stored answer key of a rally: one key per step, in step order. Kept apart from the
 * editor component so the eagerly loaded module file never pulls the form into the bundle.
 */
import type { CompositeDefinition } from "./types";

export interface CompositeSolution {
  children: unknown[];
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function emptySolution(definition: CompositeDefinition): CompositeSolution {
  return { children: (definition.children ?? []).map(() => ({})) };
}

/** Reads whatever is stored and pads it out to one slot per step. */
export function childSolutions(definition: CompositeDefinition, value: unknown): unknown[] {
  const stored = isRecord(value) && Array.isArray(value.children) ? value.children : [];
  return (definition.children ?? []).map((_, index) => stored[index]);
}
